import { Link } from "react-router-dom";
import type { TopCommentItem } from "@/types/content";
import { formatCount } from "@/utils/format";

const rankStyles: Record<number, string> = {
  1: "bg-primary-500 text-background-50",
  2: "bg-accent-500 text-foreground-950",
  3: "bg-secondary-500 text-background-50",
};

export default function RankItem({ item, rank }: { item: TopCommentItem; rank: number }) {
  const style = rankStyles[rank] ?? "bg-background-200 text-foreground-700";
  const isMedal = rank <= 3;

  return (
    <article className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6">
      <div className="flex shrink-0 flex-col items-center gap-1">
        <span
          className={`flex h-11 w-11 items-center justify-center rounded-lg font-heading text-lg font-black ${style}`}
        >
          {rank}
        </span>
        {isMedal && (
          <span className="text-[10px] font-semibold tracking-wide text-foreground-500">
            {rank === 1 ? "榜首" : rank === 2 ? "亚军" : "季军"}
          </span>
        )}
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-foreground-950 text-xs font-bold text-background-50">
            {item.nickname.slice(0, 1)}
          </span>
          <span className="text-sm font-semibold text-foreground-950">{item.nickname}</span>
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-semibold text-secondary-900">
            {item.categoryName}
          </span>
        </div>

        <p className="mt-3 font-heading text-base leading-relaxed text-foreground-900 md:text-lg">
          {item.content}
        </p>

        <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-background-200 pt-3.5">
          <Link
            to={`/event/${item.eventId}`}
            className="inline-flex items-center gap-1.5 truncate text-xs text-foreground-600 transition-colors hover:text-primary-600 md:text-sm"
          >
            <i className="ri-link text-sm"></i>
            出自：{item.eventTitle}
          </Link>
          <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-thumb-up-fill text-sm"></i>
            {formatCount(item.likes)}
          </span>
        </div>
      </div>
    </article>
  );
}